module.exports = __webpack_public_path__ + "img/sao_blue.6831e182.png";